// REDUCER
import * as actionTypes from '../constants/actions';
import deepEqual from 'deep-equal';

const defaultState = {
	menuActive: false,
	selectedMenu: null,
	mainMenu: konfig.navigation || {},
	subMenu: {},
	footer: konfig.footer || {},
	searchActive: false,
	socialLinks: konfig.socialLinks || {},
};

function toggleMenu(state) {
	return {
		...state,
		menuActive: !state.menuActive,
		searchActive: false,

		selectedMenu: null,
		subMenu: {},
	};
}

function toggleSearchMenu(state) {
	return {
		...state,
		searchActive: !state.searchActive,
		menuActive: false,
	};
}

function menuReceivedData(state, payload) {
	if (payload.mainMenu.hasOwnProperty('items')) {
		return {...state, mainMenu: payload.mainMenu, socialLinks: payload.socialLinks};
	}

	return state;
}

function activateSubmenu(state, payload) {
	let menu = {
		items: [],
	};

	if (payload.hasOwnProperty('items') && payload.items.length) {
		//if the same menu was clicked treat it as a toggle
		if (!deepEqual(state.subMenu.items, payload.items)) {
			menu.items = payload.items;
		}
	} else {
		// if the activated menu-item has no sub-items we just navigated there, so we can close the menu.
		state = toggleMenu(state);
	}

	return {
		...state,
		subMenu: menu,
		selectedMenu: menu.items.length ? payload : null,
	};
}

function closeMenu(state) {
	return {
		...state,
		menuActive: false,
		searchActive: false,

		selectedMenu: null,
		subMenu: {},
	};
}

export default function menuReducer(state = defaultState, action) {
	switch (action.type) {
		case actionTypes.MENU_TOGGLE:
			return toggleMenu(state);
			break;
		case actionTypes.MENU_CLOSE:
			return closeMenu(state);
			break;
		case actionTypes.MENU_TOGGLE_SEARCH:
			return toggleSearchMenu(state);
			break;
		case actionTypes.MENU_RECV_DATA:
			return menuReceivedData(state, action.payload);
		case actionTypes.MENU_UPDATE_SUB:
			return activateSubmenu(state, action.payload);
		default:
			return state;
	}
}



/** WEBPACK FOOTER **
 ** ./frontend/reducers/menu.js
 **/